export default {
  setCourses(state, courses) {
    state.courses = courses;
  },
  setCourse(state, course) {
    state.course = course;
  },
  setCategories(state, categories) {
    state.categories = categories;
  },
  setLastLessons(state, lastLessons) {
    state.lastLessons = lastLessons;
  }
};
